// @ts-nocheck
// CS-B: modal "Comprar os livros do clube" — lista os livros do clube que o
// owner marcou com link de compra (genérico da loja ou afiliado dele). Pro
// membro que ainda não tem o livro (ou quer se antecipar na sequência).
// Links externos abrem no navegador do sistema (target=_blank no Capacitor).
import React from 'react';
import { Icon } from '../icons';

export const ClubBuyBooksModal: React.FC<{
  open: boolean;
  onClose: () => void;
  links: any[];
  term?: 'clube' | 'grupo';
}> = ({ open, onClose, links = [], term = 'clube' }) => {
  if (!open) return null;
  const items = (links || []).filter((b) => b && b.buyUrl);

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 9500, background: 'rgba(20,16,14,0.6)', backdropFilter: 'blur(4px)' }} />
      <div style={{
        position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 9501,
        background: 'var(--paper)', borderTopLeftRadius: 24, borderTopRightRadius: 24,
        padding: '14px 20px calc(28px + env(safe-area-inset-bottom, 0px))',
        maxWidth: 460, margin: '0 auto', maxHeight: '86vh', overflowY: 'auto',
        boxShadow: '0 -16px 40px rgba(0,0,0,0.22)',
      }}>
        <div style={{ width: 40, height: 4, borderRadius: 2, background: 'var(--line)', margin: '0 auto 16px' }} />
        <div className="serif" style={{ fontSize: 22, lineHeight: 1.1 }}>Comprar os livros do {term}</div>
        <div style={{ fontSize: 13, color: 'var(--ink-3)', marginTop: 6, marginBottom: 16, lineHeight: 1.45 }}>
          Garanta seu exemplar pra ler junto. Você pode se antecipar e já pegar os próximos da fila.
        </div>

        {items.length === 0 ? (
          <div style={{ fontSize: 13.5, color: 'var(--ink-3)', padding: '24px 0', textAlign: 'center' }}>
            Nenhum link de compra disponível ainda.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {items.map((b, i) => (
              <div key={b.id || i} style={{
                display: 'flex', alignItems: 'center', gap: 12,
                padding: 12, borderRadius: 16, background: 'var(--paper-2)', border: '1px solid var(--line)',
              }}>
                <div style={{
                  width: 40, height: 56, borderRadius: 7, flexShrink: 0, overflow: 'hidden',
                  background: `linear-gradient(135deg, oklch(0.78 0.09 ${b.coverHue ?? 22}), oklch(0.45 0.10 ${b.coverHue ?? 22}))`,
                }}>
                  {b.coverUrl && <img src={b.coverUrl} alt="" onError={(e) => { e.currentTarget.style.display = 'none'; }} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className="serif" style={{ fontSize: 15, lineHeight: 1.15, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.title || 'Livro'}</div>
                  {b.author && <div style={{ fontSize: 11.5, color: 'var(--ink-3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.author}</div>}
                  {b.state === 'planned' && <div className="mono" style={{ fontSize: 9, letterSpacing: '0.12em', color: 'var(--ink-4)', textTransform: 'uppercase', marginTop: 3 }}>Próximo na fila</div>}
                </div>
                <a href={b.buyUrl} target="_blank" rel="noopener noreferrer" style={{
                  flexShrink: 0, padding: '9px 14px', borderRadius: 999,
                  background: 'var(--ember)', color: 'var(--paper)', fontSize: 13, fontWeight: 600,
                  textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6,
                }}>
                  Comprar <Icon name="arrow-right" size={14} color="var(--paper)" stroke={2} />
                </a>
              </div>
            ))}
          </div>
        )}

        <button onClick={onClose} style={{ width: '100%', marginTop: 16, padding: 13, background: 'transparent', color: 'var(--ink-3)', fontSize: 14, border: 'none', cursor: 'pointer' }}>Fechar</button>
      </div>
    </>
  );
};
